// extracted by mini-css-extract-plugin
module.exports = {"container":"NavigateionTabs_container__a1nu2","btnMobile":"NavigateionTabs_btnMobile__1VMNC"};